import React, { Component } from 'react'
import { Route, Routes,Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import adminStore from './store/store'
import Login from './pages/login';
import AdminUserList from './pages/adminUserList';
import UserList from './pages/userList';

export default class App extends Component {
  render() {
    return (
      <div>
        <Provider store={adminStore}>
          <Routes>
              <Route key="Login" path="Login" element={<Login/>}/>
              <Route key="AdminUserList" path="AdminUserList" element={<AdminUserList/>} />
              <Route key="UserList" path="UserList" element={<UserList/>} />
              <Route key="notFound" path="*" element={<Navigate replace to="/admin/Login"/>} />
          </Routes>
        </Provider>
      </div>
    )
  }
}
